export default __webpack_public_path__ + "static/media/dark-domi-logo.d1160172.svg";